@if (relevantLine) {
<div>
  <a class="line-search-row-link flex justify-between items-center cursor-pointer" [href]="lineSearchUrl"
    [attr.aria-label]="lineButtonAriaLabel" (click)="onLineLinkClick($event, relevantLine)">
    <div class="flex flex-col">
      <div class="flex gap-2 items-center max-w-[12rem]" [ngClass]="{'!text-[#D4282E] !line-through': isRouteCanceled()}">
        <app-line-details [line]="relevantLine" (onAgencyClick)="onAgencyClick($event)" [isPointer]="false"
          [tripHeadSign]="getStopTimeTripHeadSign()" />

      </div>
      <div class="flex gap-2 items-center" [ngClass]="{'!text-[#D4282E] !line-through': isRouteCanceled()}">
        @if (stopTime.isPickUp && !stopTime.isDropOff) {
        <span class="text-red-500 text-xs">{{onlyDropOffText}}</span>
        }
        @if (stopTime.isDropOff && !stopTime.isPickUp) {
        <span class="text-red-500 text-xs">{{pickUpOnlyText}}</span>
        }
        @if (stopTime.isPickUp && stopTime.isDropOff) {
        <span class="text-red-500 text-xs">{{noPickupOrDropOffText}}</span>
        }
        @if (stopTime.platformNumber && !stopTime.isPickUp) {
        <span class="text-subText text-xs">
          {{departureFromPlatformText}} {{stopTime.platformNumber}}
        </span>
        }
      </div>
    </div>
    <div class="flex items-center gap-2">
      @if (relevantRouteMessages.length) {
      <mot-button [icon]="'message-exclamation'" [text]="relevantRouteMessages.length + ' ' + specialMessagesText"
        buttonClass="!bg-[#D4282E] !rounded-lg !text-white !pr-1 !pl-[0.375rem] !h-[1.5rem]"
        textClass="!text-sm !font-normal" ariaHaspopup="dialog"
        (onClick)="openSpecialMessages(relevantRouteMessages); $event.stopPropagation()" />
      }
      <span [ngClass]="{
            'text-[#008667]': isToday && stopTime.realTimeDepartureTime,
            '!text-[#D4282E] !line-through': isRouteCanceled()
          }">{{stopTime.departureTimeToShow | hour}}</span>
    </div>
  </a>
</div>
}